import React from 'react'
import Skeleton from 'react-loading-skeleton'

import QuantityCell from './QuantityCell'

import { DATA_QUANTITY } from '../../const/sort'

const QuantityCol = ({ classes, formik, editProductId }) => {
  return {
    header: 'Qty.',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: { minWidth: 50, maxWidth: 50, padding: 0 },
    attributes: { 'data-copy': DATA_QUANTITY },
    Cell: (productValues, productIndex) => {
      const productRowId = productValues.id
      const isInEditMode = editProductId === productRowId
      const isProductLoading = productValues.isLoading

      return isProductLoading ? (
        <Skeleton width="100%" />
      ) : (
        <QuantityCell
          formik={formik}
          productValues={productValues}
          productIndex={productIndex}
          isEditMode={isInEditMode}
        />
      )
    }
  }
}

export default QuantityCol
